import { connect } from 'react-redux';
import { tryNavigateSequence } from '../../actions/navigation';
import { selectPartyRoom } from '../../actions/partyRoom';
import { getLocationName } from '../../selectors/bookingLocation';
import { getAnyOverCrowded, getGeneralizedItems, getNumSelectedPartyRooms, hasUnlockedPartyroom, getPartyRoomsAreAvailable } from '../../selectors/partyRoom';
import { getNumberOfStationsInTimeslot } from '../../selectors/station';
import PartyRoomSelection from './PartyRoomSelection';
import { AppStep } from '../../reducers/navigation';
import { findSelectedSequencePopups } from '../../selectors/sequence';

const mapStateToProps = (state) => ({
  generalizedItems: getGeneralizedItems(state.partyRoom, state.language.selectors_party_room_js.generalized_items),
  locationName: state.bookingLocation.selectedLocation ? getLocationName(state.bookingLocation.selectedLocation) : '',
  partyRoomsData: state.partyRoom.partyRoomsData,
  selectedDate: state.date.selectedDate || new Date(),
  selectedPartyRooms: state.partyRoom.selectedPartyRooms,
  sequenceGoingForward: state.sequence.goingForward,
  totalPartyRooms: getNumSelectedPartyRooms(state.partyRoom),
  hasUnlockedRooms: getPartyRoomsAreAvailable(state.partyRoom) && hasUnlockedPartyroom(state.partyRoom, state.station),
  minumumStationsMet: hasUnlockedPartyroom(state.partyRoom, state.station),
  getAnyOverCrowded: () => getAnyOverCrowded(state.partyRoom, state.station),
  getNumberOfStationsInTimeslot: (timeslotId) => getNumberOfStationsInTimeslot(state.station, timeslotId),
  popups: findSelectedSequencePopups(state, AppStep.PartyRoom),
  languageObj: state.language.party_room_selection_js
});

const mapDispatchToProps = (dispatch) => ({
  selectPartyRoom: (timeslotId, itemId, quantity) => dispatch(selectPartyRoom(timeslotId, itemId, quantity)),
  transitionBack: () => dispatch(tryNavigateSequence(false)),
  transitionForward: () => dispatch(tryNavigateSequence(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(PartyRoomSelection);
